//------production-------
export const baseUrlAREA ="https://api-area-investigation-1024031113167.asia-southeast1.run.app";
export const baseUrlNIKKI = "https://api-nikki-1024031113167.asia-southeast1.run.app";
export const baseUrlUPLOADIMAGELAWYER = "https://api-uploadimage-lawyer-539174983798.asia-southeast1.run.app";
//------production-------

//------dev-------
// export const baseUrlAREA = "https://api-area-investigation-539174983798.asia-southeast1.run.app";
// export const baseUrlNIKKI = "https://api-nikki-539174983798.asia-southeast1.run.app";
// export const baseUrlUPLOADIMAGELAWYER = "http://localhost:8090";
//------dev-------

//------localhost-------
// export const baseUrlAREA = "http://localhost:8080";
// export const baseUrlNIKKI = "http://localhost:8081";
// export const baseUrlUPLOADIMAGELAWYER = "http://localhost:8090";
//------localhost-------

//------header-------
export const HEADERS_BASIC = {
  "Content-Type": "application/json",
  Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
};
export const HEADERS_UPIMAGE = {
  Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
};
//------header-------

export const LOAD_DG = "/api-inv/load-dg";
export const CREATE_DG = "/api-inv/create-dg";
export const UPDATE_PARCELNO = "/api-inv/update-parcelno";
export const CHECK_THAI_POST = "/api-inv/check-thai-post";
export const UPDATE_STATUS_THAI_POST = "/api-inv/update-status-thai-post";

export const LOAD_MAIN_DG = "/api-lawyer/load-main-dg";
export const LOAD_CHECK_DG = "/api-lawyer/load-check-dg";
export const CHECK_CONTNO = "/api-inv/check-contno";
export const LOAD_MAIN_CSP = "/api-inv/load-main-csp";

export const FINDLETTER = "/api-inv/findLetter";
export const CONFIRM_LETTER = "/api-inv/confirm-letter";
export const LOAD_MAIN_LETTER = "/api-inv/load-main-letter";
export const ADDLETTER = "/api-inv/addLetter";

//------IMAGE-------
export const UPLOAD_GATHER_IMAGE = "/api-lawyer/upload-gather-image"; //อัปรูป
export const LOAD_GATHER_IMAGE = "/api-lawyer/load-gather-image"; //โหลดรูป
export const GET_GATHER_IMAGE = `${baseUrlUPLOADIMAGELAWYER}/apimg-pdf/get-gather-image`; //แสดงรูป
export const DELETE_GATHER_IMAGE = `/apimg-pdf/delete-gather-image`;//ลบรูป
//------IMAGE-------